import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';
import { useDispatch, useSelector } from 'react-redux';
import { RadioOptionsWithConfirm, PhoneNumberInputWithConfirm } from 'shared-components';
import QuestionPage from '../../../templates/question';
import { Q } from '../../../../store/student/types';
import { titleAppend } from '../../../../utilities/head';
import { ApplicationState } from '../../../../store';
import {
  createNavigateForwardAction,
  createNavigateBackwardAction,
  createNavigateToAction
} from '../../../../middleware/actions';
import * as StudentActions from '../../../../store/student/actions';
import * as PIActions from '../../../../store/student/personalInfo/actions';
import { Pages } from '../../../../store/student/personalInfo/types';
import { toggleTaskMenu } from '../../../../store/ui/actions';
import { ConfigField } from '../../../../types';

const PersonalQPage10 = () => {
  const dispatch = useDispatch();

  const onPrevious = () => dispatch(createNavigateBackwardAction());
  const onNext = (config: any) => {
    dispatch(StudentActions.savePersonalInfo(Pages.PAGE10, config));
    dispatch(createNavigateForwardAction());
  };
  const onSkip = () => dispatch(createNavigateForwardAction());
  const onChange = (fieldName: string, value: any) => dispatch(PIActions.createUpdatePIFieldAction(fieldName, value));
  const onBackToTaskList = () => {
    dispatch(createNavigateToAction('/dashboard'));
    dispatch(toggleTaskMenu(false));
  };

  const {
    WhatsApp: whatsAppConfig,
    WhatsAppPhoneNumber: whatsAppPhoneNumberConfig
  }: {
    WhatsApp: ConfigField;
    WhatsAppPhoneNumber: ConfigField;
  } = useSelector(({ config }: ApplicationState) => config.Checklist.PersonalInfo.Page10);
  const { useWhatsapp: useWhatsappFromState = '', whatsAppPhoneNumber = '' } = useSelector(
    ({ student }: ApplicationState) => student.personalInfo
  );

  const sectionTitle = useSelector(({ config }: ApplicationState) => config.Checklist.PersonalInfo.shortTitle);
  const config = useSelector(({ config }: ApplicationState) => config);

  const [complete, setComplete] = useState(false);

  const currentStep = 10;
  const steps = 10;

  const [code, setCode] = useState(whatsAppPhoneNumber ? whatsAppPhoneNumber.split('-')[0] : null);
  const [phone, setPhone] = useState(whatsAppPhoneNumber ? whatsAppPhoneNumber.split('-')[1] : null);

  const [isWhatsAppOtherNumberValid, setIsWhatsAppOtherNumberValid] = useState(true);
  const [useWhatsapp, setUseWhatsapp] = useState(useWhatsappFromState);
  const [whatsAppPhoneNumberVisible, setWhatsAppPhoneNumberVisible] = useState(useWhatsapp === 'Different');

  useEffect(() => {
    setWhatsAppPhoneNumberVisible(useWhatsapp === 'Different');
  }, [useWhatsapp]);

  useEffect(() => {
    setComplete(
      useWhatsapp !== '' &&
        (!whatsAppPhoneNumberVisible || whatsAppPhoneNumber !== '') &&
        isWhatsAppOtherNumberValid &&
        (useWhatsapp === 'Different' ? code !== null && code !== '' && phone !== null && phone !== '' : true)
    );
  }, [code, phone, useWhatsapp, isWhatsAppOtherNumberValid, whatsAppPhoneNumberVisible]);

  const handleUseWhatsAppClick = (question: any) => {
    if (question.label === 'Yes, with a different number') {
      setUseWhatsapp('Different');
      onChange(Q.USE_WHATSAPP, 'Different');
    } else if (question.label === 'Yes, with the same number') {
      setUseWhatsapp('Yes');
      onChange(Q.USE_WHATSAPP, 'Yes');
    } else {
      setUseWhatsapp('No');
      onChange(Q.USE_WHATSAPP, 'No');
    }

    onChange(Q.WHATSAPP_OTHER_NUMBER, '');

    setCode(null);
    setPhone(null);
  };

  return (
    <QuestionPage
      complete={complete}
      currentStep={currentStep}
      steps={steps}
      onNext={() => onNext(config)}
      onSkip={onSkip}
      onPrevious={onPrevious}
      onBackToTaskList={onBackToTaskList}
      section={sectionTitle}
    >
      <Helmet>
        <title>
          {`${sectionTitle}: Step ${currentStep}`} {titleAppend}
        </title>
      </Helmet>

      <RadioOptionsWithConfirm
        key={Q.USE_WHATSAPP}
        id={Q.USE_WHATSAPP}
        label={'Do you use WhatsApp?'}
        inputHelperText={whatsAppConfig?.helpText}
        autofocus={true}
        onClick={(question: any) => handleUseWhatsAppClick(question)}
        questions={[
          {
            char: '1',
            label: 'Yes, with the same number',
            selected: useWhatsapp === 'Yes'
          },
          {
            char: '2',
            label: 'Yes, with a different number',
            selected: useWhatsapp === 'Different'
          },
          {
            char: '3',
            label: 'No',
            selected: useWhatsapp === 'No'
          }
        ]}
      />

      {whatsAppPhoneNumberVisible && (
        <PhoneNumberInputWithConfirm
          key={Q.WHATSAPP_OTHER_NUMBER}
          id={Q.WHATSAPP_OTHER_NUMBER}
          value={whatsAppPhoneNumber}
          autoFocus={true}
          label={'Other Phone Number'}
          codeValue={code ? code : ''}
          numberValue={phone ? phone : ''}
          inputHelperText={whatsAppPhoneNumberConfig?.helpText}
          onValidationFailed={() => {
            setIsWhatsAppOtherNumberValid(false);
            // this.props.onChange(Q.WHATSAPP_OTHER_NUMBER, ''); // removed ENR-530
          }}
          onValidationSuccess={() => {
            if (isWhatsAppOtherNumberValid !== true) {
              setIsWhatsAppOtherNumberValid(true);
            }

            const oldCode = whatsAppPhoneNumber ? whatsAppPhoneNumber.split('-')[0] : null;
            const oldPhone = whatsAppPhoneNumber ? whatsAppPhoneNumber.split('-')[1] : null;

            if (`${oldCode || ''}-${oldPhone || ''}` !== `${code || ''}-${phone || ''}`) {
              onChange(Q.WHATSAPP_OTHER_NUMBER, `${code || ''}-${phone || ''}`);
            }
          }}
          onChangeCode={(event: React.FormEvent<HTMLInputElement>) => {
            const codeVal = event.currentTarget.value;
            onChange(Q.WHATSAPP_OTHER_NUMBER, `${codeVal}-${phone}`);
            setCode(codeVal);
          }}
          onChangeNumber={(event: React.FormEvent<HTMLInputElement>) => {
            const phoneVal = event.currentTarget.value;
            onChange(Q.WHATSAPP_OTHER_NUMBER, `${code}-${phoneVal}`);
            setPhone(phoneVal);
          }}
        />
      )}
    </QuestionPage>
  );
};

export default PersonalQPage10;
